import { getHeaders } from 'auth/auth';
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../baseQuery';

//admin API'S

export const officerLoanInformationAPI = createApi({
  reducerPath: 'loanInformation',
  tagTypes: ['updateLoanInfo'],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    // add leads
    addLeads: builder.mutation({
      query: ({ data }) => {
        return {
          // Updated to backend_v2 B2B endpoint
          url: `b2b/loan/dashboard/lead`,
          method: 'POST',
          body: data,
          headers: getHeaders(),
        };
      },
      invalidatesTags: ['updateLoanInfo'],
    }),
    //get loan officer list
    getLoanOfficers: builder.query({
      query: () => {
        return {
          url: `/b2b/user/loan_officers/`,
          method: 'GET',
          headers: getHeaders(),
        };
      },
    }),
    //get leads table
    getAllLeads: builder.query({
      query: ({ data, paging, searchFilter }) => {
        return {
          url: `/b2b/loan/loa/lead_info?page_size=${paging?.limit}&page=${paging?.offset}&search=${searchFilter}`,
          method: 'POST',
          headers: getHeaders(),
          body: data,
        };
      },
      providesTags: ['updateLoanInfo'],
    }),
    //get leads detail
    getLeadDetails: builder.query({
      query: ({ user_id, application_id }) => {
        return {
          url: `/b2b/loan/dashboard/view_lead_details?user_id=${user_id}&application_id=${application_id}`,
          method: 'GET',
          headers: getHeaders(),
        };
      },
    }),
  }),
});

export const {
  useAddLeadsMutation,
  useGetLoanOfficersQuery,
  useGetAllLeadsQuery,
  useLazyGetLeadDetailsQuery,
} = officerLoanInformationAPI;
